import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textcapitalize',
})
export class UppercaseFirstPipe implements PipeTransform {
  transform(value: any, ..._args: any[]): any {
    if (value === null || typeof value === 'undefined' || value === '') {
      return '';
    }

    // Convert to string first
    const stringValue = String(value);
    return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
  }
}
